import { cn } from '../utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div className={cn('bg-foreground/30 h-4 animate-pulse rounded-md', className)} {...props} />
  );
}

export { Skeleton };
